import React from "react";
import { Megaphone, Sparkles, Radio, Heart } from "lucide-react";
import { DISTINTIVOS } from "@/data/content";

const ICONS = {
    "01": Megaphone,
    "02": Sparkles,
    "03": Radio,
    "04": Heart,
};

const COLOR_MAP = {
    orange: {
        bg: "bg-orange",
        text: "text-navy",
        shadow: "hard-shadow",
    },
    teal: {
        bg: "bg-teal",
        text: "text-cream",
        shadow: "hard-shadow-gold",
    },
    gold: {
        bg: "bg-gold",
        text: "text-navy",
        shadow: "hard-shadow",
    },
    navy: {
        bg: "bg-navy",
        text: "text-cream",
        shadow: "hard-shadow-orange",
    },
};

export default function Distintivos() {
    return (
        <section
            id="distintivos"
            data-testid="distintivos-section"
            className="bg-navy text-cream relative py-24 md:py-32 px-5 md:px-10 border-y-4 border-navy"
        >
            <div
                aria-hidden
                className="absolute inset-0 halftone-dots-cream opacity-10 pointer-events-none"
            />
            <div className="relative max-w-[1400px] mx-auto">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 fade-up">
                    <div>
                        <div className="font-display uppercase tracking-[0.3em] text-gold text-sm md:text-base mb-3">
                            / Distintivos Luna Markab
                        </div>
                        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl leading-[1.02] max-w-3xl">
                            Lo que nos hace
                            <span className="text-orange"> imbatibles.</span>
                        </h2>
                    </div>
                    <p className="text-cream/80 max-w-md text-base md:text-lg font-medium">
                        Cuatro pilares que convierten cada campaña en un evento
                        cultural.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {DISTINTIVOS.map((d, idx) => {
                        const c = COLOR_MAP[d.color];
                        const Icon = ICONS[d.n] || Sparkles;
                        return (
                            <article
                                key={d.n}
                                data-testid={`distintivo-card-${idx}`}
                                className={`${c.bg} ${c.text} ${c.shadow} border-[5px] border-cream p-7 md:p-8 flex flex-col gap-5 transition-all duration-200 hover:-translate-y-1 fade-up`}
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-heading text-5xl md:text-6xl leading-none">
                                        {d.n}
                                    </span>
                                    <Icon size={32} strokeWidth={2.2} />
                                </div>
                                <h3 className="font-display uppercase text-xl md:text-2xl tracking-wide leading-tight">
                                    {d.title}
                                </h3>
                                <p className="text-sm md:text-base leading-relaxed font-medium opacity-95">
                                    {d.body}
                                </p>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
